import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'utils/axiosBaseQuery';

export const invoiceApi = createApi({
  reducerPath: 'invoiceApi',
  baseQuery: axiosBaseQuery(),
  keepUnusedDataFor: 0,
  tagTypes: ['invoice'],
  endpoints: (builder) => ({
    getInvoice: builder.query({
      query: ({ docId }) => ({
        method: 'GET',
        path: `File/invoice/${docId}`,
      }),
      providesTags: (result, error, { docId }) => [{ type: 'invoice', id: docId }],
    }),
    uploadInvoice: builder.mutation({
      query: ({ file }) => {
        const formData = new FormData();
        formData.append('file', file);

        return {
          method: 'POST',
          path: 'File/invoice',
          data: formData,
          isFormData: true,
        };
      },
      invalidatesTags: ['invoice'],
    }),
  }),
});

export const invoiceApiReducerName = invoiceApi.reducerPath;
export const invoiceApiReducer = invoiceApi.reducer;
export const invoiceApiMiddleware = invoiceApi.middleware;

export const { useGetInvoiceQuery, useUploadInvoiceMutation } = invoiceApi;


